import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import * as fs from 'fs';
import { ProfileService } from '../profile/profile.service';
import { VillageService } from '../village/village.service';
import { ChangeStatusDTO, ComplaintDelDTO, ComplaintDTO, CTypeDTO, DelTypeDTO } from './dto/complaint.dto';
import { AllComplaintResponseModel, ComplaintResponseModel, SignalComplaintResponseModel } from './complaint-response-module';
import { ComplaintTypeEntity } from './complaint-type.entity';
import { ComplaintEntity } from './complaint.entity';
import { ComplaintFilesEntity } from './complaint-files.entity';
import { ComplaintStatusEntity } from './status-details.entity';
import { sendFCMNotifications, sendTextLocalSMS } from '../shared/mobileOTP';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { RolesEntity } from '../roles/roles.entity';
import { UserEntity } from '../user/user.entity';


@Injectable()
export class ComplaintService {
    constructor (
        @InjectRepository(ComplaintTypeEntity)
        private cTypeRepo: Repository<ComplaintTypeEntity>, 
        @InjectRepository(ComplaintEntity)
        private comRepo:Repository<ComplaintEntity>,
        @InjectRepository(ComplaintFilesEntity)
        private comFilesRepo:Repository<ComplaintFilesEntity>,
        @InjectRepository(ComplaintStatusEntity)
        private comStatus:Repository<ComplaintStatusEntity>,
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>,
        @InjectRepository(RolesEntity)
        private roleRepo:Repository<RolesEntity>,
        @InjectRepository(UserEntity)
        private useRepo:Repository<UserEntity>,
        private profileService: ProfileService,
        private villageService:VillageService,
    ) {}    
    
    async sendSMS(mobileNo:string, text: string,id:string) {
        return await sendTextLocalSMS(mobileNo, text,id)
        .then(() => {      
          console.log('sms sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending sms ', err);
          return false;
        });
    }

    async sendNotify(text) {
        return await sendFCMNotifications(text)
        .then(() => {      
          console.log('notification sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending notification ', err);
          return false;
        });
    }
    
    async createCType(queryParams, img,typeDto:CTypeDTO): Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saved = await this.cTypeRepo.save({
                    type:typeDto.type,
                    imageUrl:img.length > 0 ?img[0].attachmentsUrl:'',
                    status:true,
                    createdUser:typeDto.createdUser,
                    versionFlag:typeDto.versionFlag
                });
                if(saved) {
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Complaint type not saved')
                }
            } else {
                const saved = await this.cTypeRepo.save({
                    type:typeDto.type,
                    imageUrl:img.length > 0 ?img[0].attachmentsUrl:'',
                    status:true,
                    createdUser:typeDto.createdUser,
                    versionFlag:typeDto.versionFlag
                });
                if(saved) {
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Complaint type not saved')
                }
            }      
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateCType(queryParam, img,typeDto:CTypeDTO):Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            const oldData = await this.cTypeRepo.findOne({
                where:{Id:typeDto.Id}
            })
            if(typeDto.type) {
                typeDto.type = typeDto.type;
            } else {
                typeDto.type = oldData.type;
            }

            if(img.length > 0) {
                var fname = oldData.imageUrl.split('/')[2];
                if(fname != undefined) {
                    fs.unlinkSync('./public/complaintImages/'+fname);
                }
                typeDto.imageUrl = img[0].attachmentsUrl;
            } else {
                var fname = oldData.imageUrl.split('/')[2];
                if(fname != undefined) {
                    fs.unlinkSync('./public/complaintImages/'+fname);
                }
                typeDto.imageUrl = '';
            }
            if(queryParam.apiVersion == 1) {
                const update = await this.cTypeRepo.update(typeDto.Id,{
                    type:typeDto.type,
                    imageUrl:typeDto.imageUrl,
                    updatedUser:typeDto.updatedUser,
                    versionFlag:typeDto.versionFlag
                })
                if(update) {
                    const modified = await this.cTypeRepo.findOne({
                        where:{Id:typeDto.Id}
                    })
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type record updated';
                    response.intlCode = 11108;
                    response.data = modified;
                } else {
                    throw new ErrorResponse(99908,'Complaint type record update failed')
                }
            } else {
                const update = await this.cTypeRepo.update(typeDto.Id,{
                    type:typeDto.type,
                    imageUrl:typeDto.imageUrl,
                    updatedUser:typeDto.updatedUser,
                    versionFlag:typeDto.versionFlag
                })
                if(update) {
                    const modified = await this.cTypeRepo.findOne({
                        where:{Id:typeDto.Id}
                    })
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type record updated';
                    response.intlCode = 11108;
                    response.data = modified;
                } else {
                    throw new ErrorResponse(99908,'Complaint type record update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getTypes(queryParams,request:Request):Promise<AllComplaintResponseModel>{
        const response = new AllComplaintResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const data = await this.cTypeRepo.find({
                    where:{status:true},
                    order: { createdAt: 'DESC' },
                })
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const lop = data.map((t) => {
                    return {
                        Id:t.Id,
                        type:t.type,
                        imageUrl:t.imageUrl !=''?`${process.env.WORKINGURL}/${t.imageUrl}`:''
                    }
                });
                response.status = true;
                response.data = lop;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                const data = await this.cTypeRepo.find({
                    where:{status:true},
                    order: { createdAt: 'DESC' },
                })
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const lop = data.map((t) => {
                    return {
                        Id:t.Id,
                        type:t.type,
                        imageUrl:t.imageUrl !=''?`${process.env.WORKINGURL}/${t.imageUrl}`:''
                    }
                });
                response.status = true;
                response.data = lop;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async DeleteType(queryParams,delDto:DelTypeDTO, request:Request):Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const update = await this.cTypeRepo.update(delDto.Id,{
                    status:delDto.status,
                    updatedUser:delDto.updatedUser
                })
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type deleted successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99908,'Complaint type delete failed')
                }
            } else {
                const update = await this.cTypeRepo.update(delDto.Id,{
                    status:delDto.status,
                    updatedUser:delDto.updatedUser
                })
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Complaint type deleted successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99908,'Complaint type delete failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async createComplaint(queryParam, files,cDto:ComplaintDTO):Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            let images: any[] = [];
            cDto.status = true;
            if(queryParam.apiVersion == 1) {
                cDto.complaintStatus = 'new';
                const saved = await this.comRepo.save(cDto);
                if(!saved) {
                    throw new ErrorResponse(99908,'Complaint record save failed')
                }
                if(files.length > 0) {
                    for(let i=0;i<files.length;i++){
                        await this.comFilesRepo.save({
                            complaintId:saved.Id,
                            attachmentsUrl:files[i].attachmentsUrl
                        });
                    }                        
                }
                await this.comStatus.save({
                    complaintId:saved.Id,
                    status:'new',
                    createdUser:cDto.userId
                })
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:saved.Id},
                });     
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                let msg = {
                    to : `${user.user.fcmToken}`,
                    collapse_key : "type_a",
                    notification : {
                        body : `Your Complaint Created with ${data.Id}`,
                        title: "Create Complaint"
                    },
                    data : {
                        body : `Your Complaint Created  with ${data.Id}`,
                        title: "Create Complaint",
                        key_1 : "",
                        key_2 : ""
                    }
                }
                await this.notifyRepo.save({
                    title:'Create Complaint',
                    message:`Your Complaint Created with ${data.Id}`,
                    typeId:8,
                    userId:data.userId,
                    targetId:data.Id,
                    status:true
                })
                if(user.user.fcmToken) {
                    const nt = await this.sendNotify(msg);  
                }
                const comType = await this.cTypeRepo.findOne({
                    where:{Id:data.complaintTypeId}
                })
                const roleId = await this.roleRepo.findOne({
                    where:{roleName: Raw(alias => `UPPER(role_name) = '${comType.type.toLocaleUpperCase()}'`)},
                })
                if(roleId) {
                    const users = await this.useRepo.find({
                        where:{roleId:roleId.Id,status:true}
                    })
                    if(users) {
                        users.map((u) => {
                            this.notifyRepo.save({
                                title:'New Complaint',
                                message:`Complaint Created with ${data.Id} by ${user.firstName}`,
                                typeId:8,
                                userId:u.Id,
                                targetId:data.Id,
                                status:true
                            })
                            let msg = {
                                to : `${u.fcmToken}`,
                                collapse_key : "type_a",
                                notification : {
                                    body : `New Complaint Created with ${data.Id} by ${user.firstName}`,
                                    title: "New Complaint"
                                },
                                data : {
                                    body : `New Complaint Created  with ${data.Id} by ${user.firstName}`,
                                    title: "New Complaint",
                                    key_1 : "",
                                    key_2 : ""
                                }
                            }
                            if(u.fcmToken) {
                                this.sendNotify(msg);  
                            }
                        })                     
                    }
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint record saved';
                response.intlCode = 11108;
                response.data = final;                
            } else {
                cDto.complaintStatus = 'new';
                const saved = await this.comRepo.save(cDto);
                if(!saved) {
                    throw new ErrorResponse(99908,'Complaint record save failed')
                }
                if(files.length > 0) {
                    for(let i=0;i<files.length;i++){
                        await this.comFilesRepo.save({
                            complaintId:saved.Id,
                            attachmentsUrl:files[i].attachmentsUrl
                        });
                    }                        
                }
                await this.comStatus.save({
                    complaintId:saved.Id,
                    status:'new',
                    createdUser:cDto.userId
                })
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:saved.Id},
                });     
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                let msg = {
                    to : `${user.user.fcmToken}`,
                    collapse_key : "type_a",
                    notification : {
                        body : `Your Complaint Created with ${data.Id}`,
                        title: "Create Complaint"
                    },
                    data : {
                        body : `Your Complaint Created  with ${data.Id}`,
                        title: "Create Complaint",
                        key_1 : "",
                        key_2 : ""
                    }
                }
                await this.notifyRepo.save({
                    title:'Create Complaint',
                    message:`Your Complaint Created with ${data.Id}`,
                    typeId:8,
                    userId:data.userId,
                    targetId:data.Id,
                    status:true
                })
                if(user.user.fcmToken) {
                    const nt = await this.sendNotify(msg);  
                }
                const comType = await this.cTypeRepo.findOne({
                    where:{Id:data.complaintTypeId}
                })
                const roleId = await this.roleRepo.findOne({
                    where:{roleName: Raw(alias => `UPPER(role_name) = '${comType.type.toLocaleUpperCase()}'`)},
                })
                if(roleId) {
                    const users = await this.useRepo.find({
                        where:{roleId:roleId.Id,status:true}
                    })
                    if(users) {
                        users.map((u) => {
                            this.notifyRepo.save({
                                title:'New Complaint',
                                message:`Complaint Created with ${data.Id} by ${user.firstName}`,
                                typeId:8,
                                userId:u.Id,
                                targetId:data.Id,
                                status:true
                            })
                            let msg = {
                                to : `${u.fcmToken}`,
                                collapse_key : "type_a",
                                notification : {
                                    body : `New Complaint Created with ${data.Id} by ${user.firstName}`,
                                    title: "New Complaint"
                                },
                                data : {
                                    body : `New Complaint Created  with ${data.Id} by ${user.firstName}`,
                                    title: "New Complaint",
                                    key_1 : "",
                                    key_2 : ""
                                }
                            }
                            if(u.fcmToken) {
                                this.sendNotify(msg);  
                            }
                        })                     
                    }
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint record saved';
                response.intlCode = 11108;
                response.data = final;                
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateComplaint(queryParams, filesData, cDto:ComplaintDTO): Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            const oldData = await this.comRepo.findOne({
                where:{Id:cDto.Id}
            })
            if(cDto.complaintTypeId) {
                cDto.complaintTypeId = cDto.complaintTypeId;
            } else {
                cDto.complaintTypeId = oldData.complaintTypeId;
            }
            if(cDto.text) {
                cDto.text = cDto.text
            } else {
                cDto.text = oldData.text
            }
            if(cDto.mobileNo) {
                cDto.mobileNo = cDto.mobileNo
            } else {
                cDto.mobileNo = oldData.mobileNo
            }
            if(cDto.firstName) {
                cDto.firstName = cDto.firstName
            } else {
                cDto.firstName = oldData.firstName
            }
            if(cDto.lastName) {
                cDto.lastName = cDto.lastName
            } else {
                cDto.lastName = oldData.lastName
            }
            if(cDto.address) {
                cDto.address = cDto.address
            } else {
                cDto.address = oldData.address
            }
            if(cDto.villageId) {
                cDto.villageId = cDto.villageId
            } else {
                cDto.villageId = oldData.villageId
            }
            if(cDto.email) {
                cDto.email = cDto.email
            } else {
                cDto.email = oldData.email
            }
            if(cDto.versionFlag) {
                cDto.versionFlag = cDto.versionFlag
            } else {
                cDto.versionFlag = oldData.versionFlag
            }
            cDto.updatedUser = cDto.userId;
            let images: any[] = [];
            let finaObj = {
                complaintTypeId:cDto.complaintTypeId,
                text:cDto.text,
                mobileNo:cDto.mobileNo,
                firstName:cDto.firstName,
                lastName:cDto.lastName,
                address:cDto.address,
                villageId:cDto.villageId,
                email:cDto.email,
                userId:cDto.userId,
                updatedUser:cDto.updatedUser
            }
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.comRepo.update(cDto.Id,finaObj);
                const getOldFiles = await this.comFilesRepo.find({
                    where:{complaintId:cDto.Id}
                })
                if(filesData.length > 0)  {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        if(fname != undefined) {
                            fs.unlinkSync('./public/userComplaintImages/'+fname);
                        }
                    })
                    await this.comFilesRepo.delete({complaintId:cDto.Id});
                    await this.comFilesRepo.save(filesData);
                } else {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        if(fname != undefined) {
                            fs.unlinkSync('./public/userComplaintImages/'+fname);
                        }
                    })
                    await this.comFilesRepo.delete({complaintId:cDto.Id});
                }                
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:cDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Complaint record update failed')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint record updated';
                response.intlCode = 11108;
                response.data = final;
            } else  {
                const updatedData = await this.comRepo.update(cDto.Id,finaObj);
                const getOldFiles = await this.comFilesRepo.find({
                    where:{complaintId:cDto.Id}
                })
                if(filesData.length > 0)  {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        if(fname != undefined) {
                            fs.unlinkSync('./public/userComplaintImages/'+fname);
                        }
                    })
                    await this.comFilesRepo.delete({complaintId:cDto.Id});
                    await this.comFilesRepo.save(filesData);
                } else {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        if(fname != undefined) {
                            fs.unlinkSync('./public/userComplaintImages/'+fname);
                        }
                    })
                    await this.comFilesRepo.delete({complaintId:cDto.Id});
                }                
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:cDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Complaint record update failed')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint record updated';
                response.intlCode = 11108;
                response.data = final;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getComplaints(queryParams,userId,request:Request):Promise<AllComplaintResponseModel> {
        const response = new AllComplaintResponseModel();
        try {
            let images: any[] = [];
            const finalData: any[] = [];
            const user = await this.profileService.getUserByUId(userId);
            const role = await this.useRepo.findOne({
                relations:['roles'],
                where:{Id:userId}
            });
            const comType = await this.cTypeRepo.findOne({
                where:{type: Raw(alias => `UPPER(type) = '${role.roles.roleName.toLocaleUpperCase()}'`)},
            })
            if(queryParams.apiVersion == 1) {   
                if(role.Id == 1 || role.Id == 2) {
                    if(queryParams.type == 0) {
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: {status: true},
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 1) {
                        var sname = 'new';
                        var sname2 = 'Yet to start';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        }); 
                    } else if(queryParams.type == 2) {
                        var sname = 'In Progress';
                        var sname2 = 'InProgress';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 3) {
                        var sname = 'closed';
                        var sname2 = 'completed';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } 
                } else if(comType) {
                    if(queryParams.type == 0) {
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintTypeId:comType.Id,status: true},
                                {userId:userId, status:true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 1) {
                        var sname = 'new';
                        var sname2 = 'Yet to start';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {userId:userId, status:true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        }); 
                    } else if(queryParams.type == 2) {
                        var sname = 'In Progress';
                        var sname2 = 'InProgress';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {userId:userId, status:true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 3) {
                        var sname = 'closed';
                        var sname2 = 'completed';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                            {userId:userId, status:true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    }                    
                } else {
                    if(queryParams.type == 0) {
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: {userId:userId,status: true},
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 1) {
                        var sname = 'new';
                        var sname2 = 'Yet to start';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        }); 
                    } else if(queryParams.type == 2) {
                        var sname = 'In Progress';
                        var sname2 = 'InProgress';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 3) {
                        var sname = 'closed';
                        var sname2 = 'completed';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    }
                }
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = data.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const village = await this.villageService.getVillageById(post.villageId);
                    const postImages = await this.comFilesRepo.find({
                        where:{complaintId:post.Id}
                    });
                    return {
                        Id: post.Id,
                        complaintTypeId:post.complaintTypeId,
                        complaintType:post.complaintype.type,
                        complaintStatus:post.complaintStatus,
                        text:post.text,
                        firstName: post.firstName,
                        lastName: post.lastName,
                        mobileNo: post.mobileNo,
                        email: post.email,
                        address: post.address,
                        villageId:post.villageId,
                        villageName:village!=null?village.villageName:'',
                        createdAt:post.createdAt,
                        userId:post.userId,
                        userName: user!=null?user.firstName:'',
                        profilePic:user!=null?user.profilePic:null,
                        postImages:postImages,
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                        })
                    }                        
                    finalData.push({
                        Id: f.Id,
                        complaintTypeId:f.complaintTypeId,
                        complaintType:f.complaintType,
                        complaintStatus:f.complaintStatus,
                        text:f.text,
                        firstName: f.firstName,
                        lastName: f.lastName,
                        mobileNo: f.mobileNo,
                        email: f.email,
                        address: f.address,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        createdAt:f.createdAt,
                        userId:f.userId,
                        userName: f.firstName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        postImages:images,                        
                    }) 
                    images=[];
                }) 
                var allDevPosts = await this.comRepo.find({
                    where:{status:true},
                    order: {createdAt: "DESC"}
                });
                if(allDevPosts) {
                    var totalDevcnt = allDevPosts.length;
                } else {
                    var totalDevcnt = 0;
                }                
                if(totalDevcnt == 0) {
                    response.status = true;
                    response.data = finalData;  
                    response.percentData =  {
                        allCount:totalDevcnt,
                        newCount:0,
                        newPercentage: 0,
                        inProgressCount:0,
                        inProgressPercentage:0,
                        closedCount:0,
                        closedPercentage:0
                    }
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrived successfully';
                    response.intlCode = 11108;
                } else {
                    var cmptDevPosts = await this.comRepo.find({
                        where:[{complaintStatus:'completed',status:true},
                        {complaintStatus:'closed',status:true}],
                        order: {createdAt: "DESC"}
                    });
                    if(cmptDevPosts) {
                        var cmptDevcnt = cmptDevPosts.length;
                    } else {
                        var cmptDevcnt = 0;
                    }
                    var progressDevPosts = await this.comRepo.find({
                        where:[{complaintStatus:'inprogress',status:true},
                        {complaintStatus:'in progress',status:true}],
                        order: {createdAt: "DESC"}
                    });
                    if(progressDevPosts) {
                        var prgrsDevcnt = progressDevPosts.length;
                    } else {
                        var prgrsDevcnt = 0;
                    }
                    var startDevPosts = await this.comRepo.find({
                        where:[{complaintStatus:'new',status:true},
                        {complaintStatus:'Yet to start',status:true}],
                        order: {createdAt: "DESC"}
                    });
                    if(startDevPosts) {
                        var strtDevcnt = startDevPosts.length;
                    } else {
                        var strtDevcnt = 0;
                    }
                    var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                    var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                    var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                    response.status = true;
                    response.data = finalData;
                    response.percentData = {
                        allCount:totalDevcnt,
                        newCount:strtDevcnt,
                        newPercentage: strtPer,
                        inProgressCount:prgrsDevcnt,
                        inProgressPercentage:inproPer,
                        closedCount:cmptDevcnt,
                        closedPercentage:cmptPer
                    }
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrived successfully';
                    response.intlCode = 11108;
                }           
            }  else {
                
               if(role.Id == 1 || role.Id == 2) {
                if(queryParams.type == 0) {
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: {status: true},
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.type == 1) {
                    var sname = 'new';
                    var sname2 = 'Yet to start';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    }); 
                } else if(queryParams.type == 2) {
                    var sname = 'In Progress';
                    var sname2 = 'InProgress';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.type == 3) {
                    var sname = 'closed';
                    var sname2 = 'completed';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),status: true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                } 
            } else if(comType) {
                if(queryParams.type == 0) {
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintTypeId:comType.Id,status: true},
                            {userId:userId, status:true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.type == 1) {
                    var sname = 'new';
                    var sname2 = 'Yet to start';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {userId:userId, status:true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    }); 
                } else if(queryParams.type == 2) {
                    var sname = 'In Progress';
                    var sname2 = 'InProgress';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {userId:userId, status:true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.type == 3) {
                    var sname = 'closed';
                    var sname2 = 'completed';
                    var data = await this.comRepo.find({
                        relations:['complaintype'],
                        where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),complaintTypeId:comType.Id,status: true},
                        {userId:userId, status:true}],
                        order: { createdAt: 'DESC' },
                        skip:queryParams.skip,
                        take: 10
                    });
                }                    
                } else {
                    if(queryParams.type == 0) {
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: {userId:userId,status: true},
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 1) {
                        var sname = 'new';
                        var sname2 = 'Yet to start';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        }); 
                    } else if(queryParams.type == 2) {
                        var sname = 'In Progress';
                        var sname2 = 'InProgress';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    } else if(queryParams.type == 3) {
                        var sname = 'closed';
                        var sname2 = 'completed';
                        var data = await this.comRepo.find({
                            relations:['complaintype'],
                            where: [{complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname.toLocaleUpperCase()}'`),userId:userId,status: true},
                            {complaintStatus:Raw(alias => `UPPER(complaint_status) = '${sname2.toLocaleUpperCase()}'`),userId:userId,status: true}],
                            order: { createdAt: 'DESC' },
                            skip:queryParams.skip,
                            take: 10
                        });
                    }
                }
            if(!data) {
                throw new ErrorResponse(99908,'Data not found')
            }
            const promises = data.map(async (post) => {
                const user = await this.profileService.getUserByUId(post.userId);
                const village = await this.villageService.getVillageById(post.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:post.Id}
                });
                return {
                    Id: post.Id,
                    complaintTypeId:post.complaintTypeId,
                    complaintType:post.complaintype.type,
                    complaintStatus:post.complaintStatus,
                    text:post.text,
                    firstName: post.firstName,
                    lastName: post.lastName,
                    mobileNo: post.mobileNo,
                    email: post.email,
                    address: post.address,
                    villageId:post.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:post.createdAt,
                    userId:post.userId,
                    userName: user!=null?user.firstName:'',
                    profilePic:user!=null?user.profilePic:null,
                    postImages:postImages,
                }   
            });   
            const da = await Promise.all(promises);
            da.map((f) => {  
                if(f.postImages) {
                    f.postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }                        
                finalData.push({
                    Id: f.Id,
                    complaintTypeId:f.complaintTypeId,
                    complaintType:f.complaintType,
                    complaintStatus:f.complaintStatus,
                    text:f.text,
                    firstName: f.firstName,
                    lastName: f.lastName,
                    mobileNo: f.mobileNo,
                    email: f.email,
                    address: f.address,
                    villageId:f.villageId,
                    villageName:f.villageName,
                    createdAt:f.createdAt,
                    userId:f.userId,
                    userName: f.firstName,
                    profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                    postImages:images,                        
                }) 
                images=[];
            }) 
            var allDevPosts = await this.comRepo.find({
                where:{status:true},
                order: {createdAt: "DESC"}
            });
            if(allDevPosts) {
                var totalDevcnt = allDevPosts.length;
            } else {
                var totalDevcnt = 0;
            }                
            if(totalDevcnt == 0) {
                response.status = true;
                response.data = finalData;  
                response.percentData =  {
                    allCount:totalDevcnt,
                    newCount:0,
                    newPercentage: 0,
                    inProgressCount:0,
                    inProgressPercentage:0,
                    closedCount:0,
                    closedPercentage:0
                }
                response.statusCode = 50000;
                response.internalMessage = 'Data retrived successfully';
                response.intlCode = 11108;
            } else {
                var cmptDevPosts = await this.comRepo.find({
                    where:[{complaintStatus:'completed',status:true},
                    {complaintStatus:'closed',status:true}],
                    order: {createdAt: "DESC"}
                });
                if(cmptDevPosts) {
                    var cmptDevcnt = cmptDevPosts.length;
                } else {
                    var cmptDevcnt = 0;
                }
                var progressDevPosts = await this.comRepo.find({
                    where:[{complaintStatus:'inprogress',status:true},
                    {complaintStatus:'in progress',status:true}],
                    order: {createdAt: "DESC"}
                });
                if(progressDevPosts) {
                    var prgrsDevcnt = progressDevPosts.length;
                } else {
                    var prgrsDevcnt = 0;
                }
                var startDevPosts = await this.comRepo.find({
                    where:[{complaintStatus:'new',status:true},
                    {complaintStatus:'Yet to start',status:true}],
                    order: {createdAt: "DESC"}
                });
                if(startDevPosts) {
                    var strtDevcnt = startDevPosts.length;
                } else {
                    var strtDevcnt = 0;
                }
                var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                response.status = true;
                response.data = finalData;
                response.percentData = {
                    allCount:totalDevcnt,
                    newCount:strtDevcnt,
                    newPercentage: strtPer,
                    inProgressCount:prgrsDevcnt,
                    inProgressPercentage:inproPer,
                    closedCount:cmptDevcnt,
                    closedPercentage:cmptPer
                }
                response.statusCode = 50000;
                response.internalMessage = 'Data retrived successfully';
                response.intlCode = 11108;
            }  
        }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getComplaintById(queryParams,Id,request:Request):Promise<SignalComplaintResponseModel> {
        const response = new SignalComplaintResponseModel();
        try {
            let images: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:Id},
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:Id},
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateComplaintStatus(queryParams,changeDto:ChangeStatusDTO, request:Request):Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            let images: any[] = [];
            await this.comStatus.update({complaintId:changeDto.Id},{isActive:false})
            if(queryParams.apiVersion ==1) {
                const update = await this.comRepo.update(changeDto.Id,{complaintStatus:changeDto.complaintStatus,updatedUser:changeDto.updatedUser});
                if(!update) {
                    throw new ErrorResponse(99998, 'Complaint status failed to change')
                }
                await this.comStatus.save({
                    complaintId:changeDto.Id,
                    status:changeDto.complaintStatus,
                    createdUser:changeDto.updatedUser
                })
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:changeDto.Id},
                });
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint status changed successfully';
                response.intlCode = 11108;
            } else {
                const update = await this.comRepo.update(changeDto.Id,{complaintStatus:changeDto.complaintStatus,updatedUser:changeDto.updatedUser});
                if(!update) {
                    throw new ErrorResponse(99998, 'Complaint status failed to change')
                }
                await this.comStatus.save({
                    complaintId:changeDto.Id,
                    status:changeDto.complaintStatus,
                    createdUser:changeDto.updatedUser
                })
                const data = await this.comRepo.findOne({
                    relations:['complaintype'],
                    where: {Id:changeDto.Id},
                });
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.comFilesRepo.find({
                    where:{complaintId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    complaintTypeId:data.complaintTypeId,
                    complaintType:data.complaintype.type,
                    complaintStatus:data.complaintStatus,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint status changed successfully';
                response.intlCode = 11108;
            }
            return response;
        } catch(error) {
            throw error;
        }
    }

    async getComplaintStatus(queryParams,userId,request:Request):Promise<AllComplaintResponseModel> {
        const response = new AllComplaintResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const data = await this.comRepo.find({
                    relations:['complaintype'],
                    where: {status: true},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take: 10
                });
                if(!data) {
                    throw new ErrorResponse(99998, 'Data not found') 
                }
                const final = data.map((post) => {
                    return {
                        Id: post.Id,
                        complaintTypeId:post.complaintTypeId,
                        complaintType:post.complaintype.type,
                        complaintStatus:post.complaintStatus,
                        createdAt:post.createdAt
                    }   
                });
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                   
            } else {
                const data = await this.comRepo.find({
                    relations:['complaintype'],
                    where: {status: true},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take: 10
                });
                if(!data) {
                    throw new ErrorResponse(99998, 'Data not found') 
                }
                const final = data.map((post) => {
                    return {
                        Id: post.Id,
                        complaintTypeId:post.complaintTypeId,
                        complaintType:post.complaintype.type,
                        complaintStatus:post.complaintStatus,
                        createdAt:post.createdAt
                    }   
                });
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                   
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getComplaintDetailedStatus(queryParams,Id,request:Request):Promise<AllComplaintResponseModel> {
        const response = new AllComplaintResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const data = await this.comStatus.find({
                    where: {complaintId: Id},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99998, 'Data not found') 
                }
                const final = data.map((post) => {
                    return {
                        Id: post.Id,
                        complaintId:post.complaintId,
                        status:post.status,
                        createdAt:post.createdAt,
                        createdUser:post.createdUser
                    }   
                });
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                   
            } else {
                const data = await this.comStatus.find({
                    where: {complaintId: Id},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99998, 'Data not found') 
                }
                const final = data.map((post) => {
                    return {
                        Id: post.Id,
                        complaintId:post.complaintId,
                        status:post.status,
                        createdAt:post.createdAt,
                        createdUser:post.createdUser
                    }   
                });
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                   
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteComplaint(queryParams, delDto:ComplaintDelDTO, request:Request):Promise<ComplaintResponseModel> {
        const response = new ComplaintResponseModel();
        try {
            const update = await this.comRepo.update(delDto.Id, delDto);
            if(update) {
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Complaint deleted successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Complaint delete failed')
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
